import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

/**
 * 静态路由（Layout内）
 */
export const staticLayoutRoutes: RouteRecordRaw[] = [
    {
        path: '/personal-details',
        name: 'PersonalDetails',
        component: () => import('@/views/system/user/Info.vue'),
        meta: {
            title: '个人详情',
            hidden: true
        }
    },
    // {
    //     path: '/home',
    //     name: 'Home',
    //     component: () => import('@/views/home/index.vue'),
    //     meta: {
    //         title: '首页',
    //         icon: 'https://unpkg.com/@vbenjs/static-source@0.1.7/source/logo-v1.webp',
    //         noCache: true,
    //         link: null,
    //         type: 'M',
    //         hidden: false,
    //         permissions: ['*'],
    //         roles: ['admin'],
    //         isHome: true // 是否为默认首页
    //     }
    // },
    // {
    //     path: '/overview',
    //     name: 'Overview',
    //     component: () => import('@/views/overview/index.vue'),
    //     meta: {
    //         title: '组件',
    //         icon: 'file:assets/images/menus/icon-jkpt.png',
    //         activeIcon: 'file:assets/images/menus-d/icon-jkpt.png',
    //         noCache: true,
    //         link: null,
    //         type: 'M',
    //         hidden: false,
    //         permissions: ['*'],
    //         roles: ['admin']
    //     }
    // },
    {
        path: '/:notFoundPath(.*)*',
        name: '404',
        component: () => import('@/views/404/index.vue'),
        meta: {
            hidden: true
        }
    }
]
/**
 * 静态路由（Layout外）
 */
export const staticPageRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Layout',
        component: () => import('@/views/layout/index.vue'),
        children: [...staticLayoutRoutes],
        meta: {
            title: '',
            hidden: true,
            permissions: ['*'],
            roles: ['admin'],
            icon: 'user'
        }
    },
    // {
    //     path: '/redirect',
    //     name: 'Redirect',
    //     component: () => import('@/views/layout/index.vue'),
    //     meta: {
    //         hidden: true
    //     },
    //     children: [
    //         {
    //             path: '/redirect/:path(.*)',
    //             component: () => import('@/views/redirect/index.vue')
    //         }
    //     ]
    // },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
        meta: {
            hidden: true,
            permissions: ['*'],
            roles: ['admin'],
            auth: false,
            buttons: [
                {
                    label: '新增',
                    code: 'add'
                }
            ]
        }
    }
]

const router = createRouter({
    strict: true,
    history: createWebHistory(import.meta.env.VITE_BASE_PATH),
    routes: staticPageRoutes
})

export const setupRouter = app => {
    app.use(router)
}

export default router
